import { render, staticRenderFns } from "./SchemaMarkup.vue?vue&type=template&id=ff9f5894&"
import script from "./SchemaMarkup.vue?vue&type=script&lang=js&"
export * from "./SchemaMarkup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports